import React from 'react';
import { audienceFit } from '../data/content';
import Reveal from './Reveal';
import './AudienceFit.css';

/** Pre koho je California – krátke cieľové skupiny. */
export default function AudienceFit() {
  return (
    <section className="section" id="pre-koho">
      <div className="container">
        <Reveal className="section-heading">
          <span className="eyebrow">Pre koho je California</span>
          <h2>Nájdeš sa v tom?</h2>
        </Reveal>

        <div className="audience">
          {audienceFit.map((item, index) => (
            <Reveal key={item.title} delay={Math.min(index * 0.08, 0.32)}>
              <article className="audience__item">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
